export default class RequestMailService {
  get recipientDomain() {
    return process.env.MAIL_TO_REQUEST
  }
}
